module.exports = __webpack_public_path__ + "media/icons/search-a9ed23cf1e5766ba9badeda50e470ba3.svg";